import React from 'react';
import { connect } from 'react-redux';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import { Select, TextField } from '@material-ui/core';

import style from '../awbReturn.module.css';
import commonStyles from '../../../common/common.module.css';
import AlternativePaymentOptions from '../../../../models/PaymentOptions';
import { PaymentType } from '../../../../models/PaymentType.enum';

const styles = (theme: Theme) =>

  createStyles({
    formControlLabel: {
      marginRight: '2%',
      '& p': {
        fontSize: '14px'
      }
    },
    label: {
      color: 'rgb(9, 43, 74)'
    }
  });

interface PaymentInfoComponentProps {
  classes: any;
  returnCharges: string;
  handleChange: (type: string, event: any) => void;
  paymentOptions: AlternativePaymentOptions;
  paymentType: string;
  paymentInfoSelect: string;
};

const paymentInfoComponent = (props: PaymentInfoComponentProps) => {

  const { classes } = props;
  let payOptions: any = [];

  if(props.paymentOptions.options) {
    payOptions = props.paymentOptions.options.options.map((item: any, index: number ) => {
      return (
        <option key={ index } value={ item.value }>{ item.name }</option> 
      );
    });
  }

  return (
    <div className={`${commonStyles.wrapper} ${style.wrapper} ${commonStyles.h100}`}>
      <h3 className={`${commonStyles.header}`} >Paid Via</h3>
      <div className={style.inputsWrapper} >
        <label className={commonStyles.inputLabel}>Enter Payment Info<span className={style.asterisk}>*</span></label>

        <Select
          native
          value={props.paymentInfoSelect}
          onChange={(event: any) => props.handleChange('paymentInfoSelect', event)}
          inputProps={{
            name: 'company',
            id: 'company',
            className: classes.styleInputProps,
          }}
          className={`${classes.select}`}
          variant="outlined"
        >
          <option value={0} />
          {payOptions}
        </Select>
        <span></span>
      </div>
      {props.paymentInfoSelect === 'other' &&
        <div className={`${commonStyles.inputLabelWrapper}`}>
           <TextField
            required
            id='reason'
            label='Specify payment method'
            value={props.returnCharges}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => props.handleChange('returnCharges', event)}
            variant='outlined'
            fullWidth
            className={ commonStyles.customTextField }
            InputProps={{
              classes: {
                notchedOutline: `${ commonStyles.noNotch }`,
              },
            }}
            InputLabelProps={{
              shrink: true,
              className: commonStyles.customLabelProp,
            }}
            error={props.paymentType === PaymentType.ALTERNATIVE_PAYMENT && !props.returnCharges}
          />
        </div>
      }
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    manualEntryEdit: state.manualEntryEdit,
    manualEntryAdd: state.manualEntryAdd
  };
}

export default withStyles(styles)(connect(mapStateToProps, {})(paymentInfoComponent));
